import { Col, Input, Row } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { RootStoresContext } from '../../stores/RootStore';
import { cleanString } from '../../util/renderHelpers';

import { ReactComponent as IconBanner } from '../../icons/icon-banner.svg';
import { ReactComponent as IconSearch } from '../../icons/icon-search.svg';

export const HeaderBannerSearch: React.FC = () => {
  const history = useHistory();
  const [value, setValue] = useState('');

  const inputHandler = (el: React.ChangeEvent<HTMLInputElement>) => setValue(el.target.value);

  const searchHandler = (searchValue: string) => {
    history.push(`${process.env.REACT_APP_BASE_PATH || ''}/search?query=${searchValue}`);
    setValue('');
  };

  return (
    <HeaderBanner>
      <Col className="banner__search" xs={{ span: 24 }} lg={{ span: 16 }}>
        <Input.Search
          autoComplete="off"
          spellCheck={false}
          className="search__input"
          placeholder="Search for keyword"
          name="Search Banner Input"
          aria-label="Search Banner Input"
          onChange={inputHandler}
          value={value}
          onSearch={searchHandler}
          enterButton={
            <button aria-label="Search" className="search-toggle" title="Search">
              <IconSearch />
            </button>
          }
        />
      </Col>
    </HeaderBanner>
  );
};

const HeaderBanner: React.FC = observer(({ children }) => {
  const rootStore = useContext(RootStoresContext);

  return !rootStore.pageStore.isPending ? (
    <Col id="banner" className="banner">
      <div className="banner__wrapper">
        <Row className="fixed" type="flex">
          <Col className="banner__heading" xs={{ span: 24 }} lg={{ span: 14 }}>
            {rootStore.pageStore.currentPage ? (
              <h1 className="page__title">
                {cleanString(rootStore.pageStore.currentPage.pageName)}
              </h1>
            ) : (
              ''
            )}
          </Col>
          {children}
        </Row>
      </div>
      {!rootStore.appStore.isMobile && (
        <div className="banner__cover">
          <IconBanner />
        </div>
      )}
    </Col>
  ) : null;
});

export default HeaderBanner;
